import { render, staticRenderFns } from "./uberTabbedSection.vue?vue&type=template&id=631661a3&scoped=true&"
import script from "./uberTabbedSection.vue?vue&type=script&lang=js&"
export * from "./uberTabbedSection.vue?vue&type=script&lang=js&"
import style0 from "./uberTabbedSection.vue?vue&type=style&index=0&id=631661a3&scoped=true&lang=css&"
import style1 from "./uberTabbedSection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631661a3",
  null
  
)

component.options.__file = "uberTabbedSection.vue"
export default component.exports